// extracted by mini-css-extract-plugin
export default {"control":"Product_control__lkNec","richText":"Product_richText__6lUUP"};